import * as common from '@/store/common/mutation-types';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const STATE_INIT = 'STATE_INIT';
export const CAMPAIGN_INFO_INIT = 'CAMPAIGN_INFO_INIT';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const PAGING_INFO = 'PAGING_INFO';
export const CAMPAIGN_INFO = 'CAMPAIGN_INFO';

export default {
	...common,
	DEFAULT_ASSIGN,
	STATE_INIT,
	CAMPAIGN_INFO_INIT,
	SEARCH_PARAM,
	PAGING_INFO,
	CAMPAIGN_INFO
};
